import videojs from 'video.js';

const Button = videojs.getComponent('Button');

class ShareButton extends Button {
  private _options: any;

  constructor(player, options) {
    super(player, options);
    this._options = options;
    this.addClass('vjs-menu-button');
    this.addClass('vjs-share-control');
    this.addClass('vimeo-video__btn-share');
    this.applyState();
  }

  handleClick() {
    this.player().trigger('share');
  }

  updateState(options) {
    this._options = {
      ...this._options,
      ...options,
    };

    this.applyState();
  }

  private applyState() {
    const isPrivate = !!this._options?.isPrivate;

    this.removeClass('vjs-icon-share');
    this.removeClass('vimeo-video__btn-share--private');

    if (isPrivate) {
      this.addClass('vimeo-video__btn-share--private');
      this.setAttribute('title', 'Private video');
      this.setAttribute('aria-label', 'Private video');
      return;
    }

    this.addClass('vjs-icon-share');
    this.setAttribute('title', 'Share');
    this.setAttribute('aria-label', 'Share');
  }
}

export default ShareButton;
